import { useCallback, useEffect, useRef, useState } from "react";
import type { CreateGameFormProps } from "../../game-registry";

const PLAYER_COUNT_OPTIONS = [
  { value: 2, label: "2명" },
  { value: 3, label: "3명" },
  { value: 4, label: "4명" },
] as const;

const DEFAULT_PLAYER_COUNT = 2;

export function StoneFlickingCreateGameForm({
  onConfigChange,
}: CreateGameFormProps) {
  const [playerCount, setPlayerCount] = useState<2 | 3 | 4>(
    DEFAULT_PLAYER_COUNT,
  );
  const onConfigChangeRef = useRef(onConfigChange);
  onConfigChangeRef.current = onConfigChange;

  // Notify parent of default config on mount (once only)
  useEffect(() => {
    onConfigChangeRef.current({ playerCount: DEFAULT_PLAYER_COUNT });
  }, []);

  const handleChange = useCallback(
    (count: 2 | 3 | 4) => {
      setPlayerCount(count);
      onConfigChange({ playerCount: count });
    },
    [onConfigChange],
  );

  return (
    <div className="flex flex-col gap-2">
      <span
        className="font-medium text-sm"
        style={{ color: "var(--cn-asf-text-muted)" }}
      >
        플레이어 수
      </span>
      <div className="flex gap-2">
        {PLAYER_COUNT_OPTIONS.map((opt) => {
          const active = playerCount === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              className="rounded-md px-4 py-2 font-medium text-sm transition-colors"
              style={{
                backgroundColor: active
                  ? "var(--cn-asf-stone-p1)"
                  : "var(--cn-asf-surface-secondary)",
                color: active ? "#fff" : "var(--cn-asf-text)",
                border: active
                  ? "1px solid var(--cn-asf-stone-p1)"
                  : "1px solid var(--cn-asf-surface-border)",
              }}
              onClick={() => handleChange(opt.value)}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
